module.exports = __webpack_public_path__ + "static/img/cca-5.2c8c25d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact/cca-5.png
// module id = 963
// module chunks = 0